<input id="display-message" class="greeting-button-deselected display-message"
            bind:value={display_message} on:input={messageChanged}>

<script>
    export let display_message = ''

    function messageChanged() {
        navigator.clipboard.writeText(display_message);
    }
</script>